import type { Company } from '@/constants/companies'

import Asset from '@/components/ui/asset'
import { cn } from '@/lib/utils'

interface CompanyMarkProps {
    company?: Company | null
    className?: string
    logoClassName?: string
}

export default function CompanyMark({ company, className, logoClassName }: CompanyMarkProps) {
    const initial = (
        <span className='caption-style text-soft'>
            {company?.name.slice(0, 1) || '?'}
        </span>
    )

    return (
        <span
            className={cn(
                'bg-muted flex size-6 shrink-0 items-center justify-center overflow-hidden rounded-md shadow-[0px_0px_0px_1px_#232323]',
                className
            )}
        >
            {company?.logo ? (
                <Asset
                    src={company.logo}
                    alt=''
                    width={1}
                    height={1}
                    fit='contain'
                    fallback={initial}
                    className={cn('size-[60%]', logoClassName)}
                />
            ) : initial}
        </span>
    )
}
